import { render, staticRenderFns } from "./CorpsPieceDetail.vue?vue&type=template&id=8295ffcc&scoped=true"
import script from "./CorpsPieceDetail.vue?vue&type=script&lang=js"
export * from "./CorpsPieceDetail.vue?vue&type=script&lang=js"
import style0 from "./CorpsPieceDetail.vue?vue&type=style&index=0&id=8295ffcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8295ffcc",
  null
  
)

export default component.exports